import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private currentLanguageSubject = new BehaviorSubject<string>('en');
  public currentLanguage$ = this.currentLanguageSubject.asObservable();

  constructor(private translateService: TranslateService) {
    // Initialize with stored language or default
    const storedLanguage = localStorage.getItem('selectedLanguage') || 'en';
    
    // Set the default language first
    this.translateService.setDefaultLang(storedLanguage);
    
    // Then set the current language
    this.setLanguage(storedLanguage);
  }

  setLanguage(lang: string): void {
    
    // Store in localStorage
    localStorage.setItem('selectedLanguage', lang);
    
    // Update the default language to ensure consistency
    this.translateService.setDefaultLang(lang);
    
    // Update the translation service
    this.translateService.use(lang).subscribe(() => {
      this.currentLanguageSubject.next(lang);
    });
  }

  getCurrentLanguage(): string {
    return this.currentLanguageSubject.value;
  }

  getAvailableLanguages(): string[] {
    return ['en', 'sr', 'hi'];
  }

  /**
   * Ensures the language is properly initialized
   * This can be called from AppComponent to guarantee language setup
   */
  ensureLanguageInitialized(): void {
    const storedLanguage = localStorage.getItem('selectedLanguage') || 'en';
    const currentLang = this.getCurrentLanguage();
    
    if (currentLang !== storedLanguage) {
      this.setLanguage(storedLanguage);
    }
  }
}
